import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
//import InputGroup from 'react-bootstrap/InputGroup';
import _ from 'lodash'
import './IncidentResponder.css'

// Actions
import { showModal } from '../../actions/modal'
import { putIncidentTag, deleteIncidentAssignment } from '../../actions/reportSummaries'

class IncidentResponder extends Component {
  constructor (props) {
    super(props)

    this.state = {
      tag: ''
    }

    this.handleTagChange = this.handleTagChange.bind(this)
    this.updateTag = this.updateTag.bind(this)
    this.getDepartment = this.getDepartment.bind(this)
    this.selectDepartment = this.selectDepartment.bind(this)
    this.selectUnit = this.selectUnit.bind(this)
    this.getResponderState = this.getResponderState.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    const { tag } = nextProps.incident

    if (tag !== this.state.tag) this.setState({ tag: tag || '' })
  }

  getDepartment (assignment) {
    const { agency } = this.props

    if (assignment.department_id) {
      if (agency.assignees) {
        var department = _.find(agency.assignees.departments, (dept) => {
          return dept._id === assignment.department_id
        })

        return department
      }
    }

    return null
  }

  getRoleUnitAndShift (assignment, timelessStart) {
    const { agency, languageCode } = this.props
    let roleUnitAndShift = ''

    if (assignment.role_id && agency.assignees) {
      var role = _.find(agency.assignees.roles, (role) => {
        return role._id === assignment.role_id
      })

      roleUnitAndShift = role ? `${role.abbreviation[languageCode]} : ` : null
    }

    if (assignment.unit_id && agency.assignees) {
      var unit = _.find(agency.assignees.units, (unit) => {
        return unit._id === assignment.unit_id
      })

      roleUnitAndShift = unit ? `${roleUnitAndShift}${unit.name[languageCode]}` : roleUnitAndShift
    }

    if (assignment.shift_id && agency.assignees) {
      var shift = _.find(agency.assignees.shifts, (shift) => {
        return shift._id === assignment.shift_id
      })

      roleUnitAndShift = shift ? `${roleUnitAndShift} ${shift.abbreviation[languageCode]}` : roleUnitAndShift
    }

    if (timelessStart) {
      return `${roleUnitAndShift} ${moment(timelessStart).utc().format('L')}`
    }

    return roleUnitAndShift || 'Assign'
  }

  selectDepartment () {
    const { incident, agency, dispatch, languageCode } = this.props
    const departmentModalProps = {
      agency,
      incident,
      reportSchemaId: incident.report_schema_id,
      assignedDepartment: incident.department_id,
      departments: agency.assignees.departments,
      languageCode
    }

    dispatch(showModal('SELECT_DEPARTMENT', departmentModalProps))
  }

  selectUnit () {
    const { incident, agency, dispatch, languageCode } = this.props
    const unitModalProps = {
      agency,
      incident,
      assignedUnit: incident.unit_id,
      units: agency.assignees.units,
      languageCode
    }

    dispatch(showModal('SELECT_UNIT', unitModalProps))
  }

  handleTagChange (event) {
    this.setState({ tag: event.target.value })
  }

  updateTag (event) {
    const { incident, dispatch } = this.props
    const tag = event.target.value
    event.preventDefault()

    if (incident.tag !== tag && tag) {
      dispatch(putIncidentTag(incident._id, incident.agency_id, incident.report_schema_id, tag))
    }
  }

  deleteIncidentAssignment (assignmentId) {
    const { incident, dispatch } = this.props

    dispatch(deleteIncidentAssignment(incident._id, incident.agency_id, incident.report_schema_id, assignmentId))
  }

  getResponderState (index = 0) {
    const { incident, agency, languageCode } = this.props
    const lastAssignments = index !== 0 ? incident.assignments[index - 1] : incident.assignments[index]
    const firstUnit = index === 1 && !lastAssignments.assignee.unit_id

    if ((index === 0 || firstUnit) && agency.report_schemas) {
      const schema = agency.report_schemas.find(schema => schema._id === incident.report_schema_id)

      if (schema) {
        const stateId = incident.responder_report_state_id ||
          schema.default_responder_state_id ||
          schema.default_state_id

        const state = schema.report_states.find(state => state._id === stateId)

        if (state) {
          return <div
            className='state-circle'
            style={{background: state.color}}
            title={state.title ? state.title[languageCode] : ''} />
        }
      }
    }

    return null
  }

  render () {
    const { incident, languageCode } = this.props
    const assignments = incident.assignments ? incident.assignments : []
    const rootAssignment = assignments[0] ? assignments[0].assignee : []
    const department = this.getDepartment(rootAssignment)

    return (
      <section>
        <div className='responder-dept'>
         <div className="assignment-row">
        <div className="assignment-label">Dept</div>
        <div className="assignment-value">

          <button
        id="dept-button"
      type="button"
      tabIndex="0"
     className={`assignment-btn assignment-dept-btn ${
        rootAssignment.length > 0
         ? assignments[0].assignee.department_id ? '' : 'required'
        : 'required'
     }`}
     onClick={this.selectDepartment}
     style={
        department
         ? { backgroundColor: department.color, color: 'white' }
         : undefined
     }
    >
     {department
       ? department.abbreviation[languageCode]
        : 'Assign'}
    </button>
</div>
</div>

   <div className="assignment-row assignment-unit-row">
    <div className="assignment-label">Unit</div>

    <div className="assignment-value">
          {assignments.map((assignment, index) => {

            if (!assignment.assignee.unit_id && assignment.assignee.department_id && assignments.length === 1) {
              return (
               <div key={index} className="assignment-inline">
                  <button
      key={index}
     id="unit-button"
     type="button"
     tabIndex="-1"
     className="assignment-btn assignment-unit-btn required"
     onClick={this.selectUnit}
    >
     Assign
    </button>
             {this.getResponderState(index)}
                </div>
              )
            } else if (!assignment.assignee.unit_id) {
              return null
            }

            return (
          <div key={index} className="assignment-inline">

              <button
       tabIndex="-1"
       id="unit-button"
        type="button"
       className={`assignment-btn assignment-unit-btn ${
         assignment.assignee.unit_id
            ? ""
            : assignment.assignee.department_id
            ? "required"
           : ""
       }`}
       onClick={this.selectUnit}
       disabled={!!assignment.assignee.unit_id}
      >
       {this.getRoleUnitAndShift(assignment.assignee, assignment.timeless_start)}
      </button>

{assignment.assignee.unit_id && (
  <button
    type="button"
    className="assignment-delete-btn del-unit"
    id="delete-button"
    onClick={() => this.deleteIncidentAssignment(assignment._id)}
    title="Delete Unit"
  >
    <span className="material-icons">close</span>
  </button>
)}
      {this.getResponderState(index)}
     </div>)
      })}

          {assignments.length > 0 && assignments[assignments.length - 1].assignee.unit_id && (
     <div className="assignment-inline">
         <button
            id="unit-button"
            tabIndex={-1}
           type="button"
           className={`assignment-btn assignment-unit-btn ${assignments[assignments.length - 1].assignee.unit_id ? 'required' : ''}`}
           onClick={this.selectUnit}
         >
           Assign
         </button>
        </div>
      )}

      {assignments.length === 0 && (
      <div className="assignment-inline">
          <button
            id="unit-button"
           tabIndex={-1}
           type="button"
          className="assignment-btn assignment-unit-btn"
           disabled
         onClick={this.selectUnit}
         >
           Assign
         </button>
         {this.getResponderState()}
       </div>
      )}
      </div>
    </div>
</div>
    <div className='responder-tag'>
    <div className="assignment-row">
    <div className="assignment-label">Tag#</div>

    <div className="assignment-value">
      <form className="tag-form" onSubmit={this.updateTag}>
        <input
          id="incident-tag"
          type="number"
          className="form-control required text-small"
          placeholder="Enter #"
          value={this.state.tag}
          onChange={this.handleTagChange}
          onBlur={this.updateTag}
          tabIndex="0"
        />
       </form>
    </div>
  </div>
</div>

      </section>      
    )
  }
}

IncidentResponder.propTypes = {
  incident: PropTypes.object.isRequired,
  agency: PropTypes.object.isRequired
}

export default connect()(IncidentResponder)
